angular.module("accordionSearchTitolari.components", [])
    .component("accordionSearchTitolari", {
        templateUrl: "ng/components/accordionSearchTitolari/accordionSearchTitolari.view.html",
        bindings: {
            listPf: '=',
            isTitolari: '<',
            isFiducianti: '<',
            domini: '<',
            startQuestionario: '<',
            checkComponent: '&',
            externalLink: '<',
            readOnly: '<',
            isFirmatari: '<',
            isPostVendita: '<',
            ndgCli: '<'
        },
        controller: SearchTitolariController,
        controllerAs: "aaccordionSearchTitolariCtrl"
    })

function SearchTitolariController(
    FinancialCustomer,
    $financialApiService,
    Pf,
    $rootScope,
    Documento,
    Sede,
    $timeout,
    $modalService,
    $typeDomainService,
    validationService,
    $scope,
    FileUploader,
    $simulationService,
    $uniService,
    $download,
    $configService,
    $portalService
) {

    var self = this;

    self.$onInit = function () {
        self.loaderRemove = [];
        self.$portalService = $portalService;
        self.testDati = {
            value: true,
            error: ""
        }
        self.validationObj = {
            documentDate: {
                disabledDays: [0],
                disabledDates: [
                    "01-01",
                    "06-01",
                    "25-04",
                    "01-05",
                    "02-06",
                    "15-08",
                    "01-11",
                    "08-12",
                    "25-12",
                    "26-12"
                ]
            }
        };
        self.tomorrow = moment()
            .add(1, "days")
            .format("DD/MM/YYYY");
        self.today = self.getTodaysDate();
        self.linkPep = '/uni/download/service-infos/' +
            encodeURIComponent('GLOSSARIO') + '/'
        self.searchObj = {}
        self.dropdown = {};
        $scope.forms = {};
        self.documentUpload = [];
        self.comuni = $rootScope.comuniMap;
        self.comuniNsil = $rootScope.mapComuniSoppressi;
        self.nazioni = $rootScope.nazioniEstere;
        self.nationCitizenship = self.nazioni.filter(
            function (element) {
                return !element.deleted
            }).map(function (element) {
                return element.name.toUpperCase();
            }).sort();
        self.nationsList = self.nazioni.filter(x => x.description != '086' && x.description != '139' && x.description != 'T86');
        self.italia = self.nazioni.filter(x => x.description == '086');
        console.log(self.nazioni);
        console.log(self.nationCitizenship);
        console.log(self.nationsList);
        self.listaProvince = self.comuni
            .map(function (comune) {
                return comune.sigla;
            })
            .filter(function (siglaComune) {
                return siglaComune != "";
            })
            .sort()
            .reduce(function (result, nextItem) {
                return result.includes(nextItem) ? result : result.concat(nextItem);
            }, []);

        self.listaProvince.push("EE")
        getListaDocumenti();
        checkTitDeleted();
        createIdEsteriFromTitEsteri();
        if (self.isFirmatari) {
            getRoles()
        }
        self.tempPerson = [];
        if (!self.listPf) {
            self.listPf = [];
        }
    }

    self.downloadInfoPep = () => {

        $download.getGenericDownload(self.linkPep)
            .then(function (response) {
                console.log(response);
            })
    }

    self.getTodaysDate = function () {

        return moment().format("DD/MM/YYYY");
    }

    var getListaDocumenti = function () {

        $typeDomainService
            .getDomainSet("RI_DROPDOWN_DOMAINS", "DOCUMENT_TYPE")
            .then(function (response) {
                self.dropdown.tipiDocumento = response.domainList;
                for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
                    if (self.dropdown.tipiDocumento[i].value == "CAE") {
                        self.dropdown.tipiDocumento[i].order = 40;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "CAI") {
                        self.dropdown.tipiDocumento[i].order = 10;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "CIE") {
                        self.dropdown.tipiDocumento[i].order = 20;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "NCE") {
                        self.dropdown.tipiDocumento[i].order = 30;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAM") {
                        self.dropdown.tipiDocumento[i].order = 50;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAS") {
                        self.dropdown.tipiDocumento[i].order = 80;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAT") {
                        self.dropdown.tipiDocumento[i].order = 60;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "UCO") {
                        self.dropdown.tipiDocumento[i].order = 70;
                    }

                }
            });
    }


    self.searchPF = function (searchForNdg) {
        if (self.userIsPresentAndHidden(searchForNdg)) {
            return;
        }
        if (self.userAlreadyAdded(searchForNdg)) {
            $rootScope.$broadcast("addAlert", {
                text: "ALREADY_ADDED"
            });
            return
        }
        self.searching = true;
        self.addForeign = false;
        self.searchingForeign = false;
        self.openSectionUpgradePf = false;
        self.tempPerson = [];
        var tempPerson = checkTitolareFirmatario();
        if (tempPerson) {
            var newUser = convertDateToTit(tempPerson)
            var newTit = createNewTit(newUser);
            self.tempPerson.push(newTit);
            self.PFresultsShown = true;
            self.searching = false;
            self.searchObj.pfcf = "";
            self.searchObj.ndg = "";
            return;
        }
        self.searchObj.pfcf = self.searchObj.pfcf && self.searchObj.pfcf.toUpperCase();
        self.PFresultsShown = true;
        var customer = FinancialCustomer.build({
            cf: self.searchObj.pfcf,
            ndg: self.searchObj.ndg,
        });

        self.disableButtonAddEstero = true;

        customer.metadata = null;
        $financialApiService
            .getCustomerByFilter(customer, true)
            .then(function (response) {

                if (response.success && response.listAppCustomer && response.listAppCustomer[0]) {
                    $financialApiService
                        .getSearchRiUserG(response.listAppCustomer[0])
                        .then(function (appCustomer) {
                            if (appCustomer.success) {
                                appCustomer.appCustomerUser.metadata.riUserG.sedeLegale.stato = appCustomer.appCustomerUser.metadata.riUserG.sedeLegale.statoEsteso
                                if (appCustomer.appCustomerUser.metadata.riUserG.isEstero) {
                                    var codCityOfBirth = self.nazioni.find(function (element) {
                                        if (!appCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato) {
                                            if (!!appCustomer.appCustomerUser.metadata.riUserG.datiNascita.statoEsteso && !!appCustomer.appCustomerUser.metadata.riUserG.datiNascita.statoEsteso.name) {
                                                appCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato = appCustomer.appCustomerUser.metadata.riUserG.datiNascita.statoEsteso
                                            } else if (!!appCustomer.appCustomerUser.metadata.riUserG.datiNascita.nazione) {
                                                appCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato = {
                                                    name: appCustomer.appCustomerUser.metadata.riUserG.datiNascita.nazione
                                                }
                                            }
                                        }
                                        return element.name.toUpperCase() == appCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato.name.toUpperCase()
                                    }).value
                                    if (!appCustomer.appCustomerUser.metadata.riUserG.sesso) {
                                        appCustomer.appCustomerUser.metadata.riUserG.sesso = "m"
                                    }
                                    appCustomer.appCustomerUser.metadata.riUserG.idEstero = validationService.createCf(appCustomer.appCustomerUser.metadata.riUserG.nome, appCustomer.appCustomerUser.metadata.riUserG.cognome, appCustomer.appCustomerUser.metadata.riUserG.datiNascita.data, appCustomer.appCustomerUser.metadata.riUserG.sesso, codCityOfBirth)
                                }

                                if (appCustomer.appCustomerUser.metadata.riUserG.domicilioDiverso && appCustomer.appCustomerUser.metadata.riUserG.domicilio) {
                                    appCustomer.appCustomerUser.metadata.riUserG.domicilio.stato = appCustomer.appCustomerUser.metadata.riUserG.domicilio.statoEsteso

                                }

                                var comuni = self.comuni.concat(self.comuniNsil);
                                var newUser = Pf.build(appCustomer.appCustomerUser.metadata.riUserG).setDefaultPfValues(self.nazioni, comuni);
                                appCustomer.appCustomerUser.metadata.riUserG.datiNascita = newUser.datiNascita;
                                appCustomer.appCustomerUser.metadata.riUserG.sesso = newUser.sesso;
                                newUser = convertDateToTit(appCustomer.appCustomerUser.metadata.riUserG)
                                var newTit = createNewTit(newUser);
                                self.tempPerson[0] = newTit
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                        .finally(function() {
                            self.searchObj.pfcf = "";
                            self.searchObj.ndg = "";
                            self.searching = false;
                            self.PFresultsShown = true;
                            self.disableButtonAddEstero = false;
                        })

                } else {
                    if (!searchForNdg) {
                        var tempUser = {
                            cf: self.searchObj.pfcf
                        }
                        var comuni = self.comuni.concat(self.comuniNsil);
                        tempUser = Pf.build(tempUser).setDefaultPfValues(self.nazioni, comuni);
                        var newUser = convertDateToTit(tempUser)
                        var newTit = createNewTit(newUser);
                        self.tempPerson[0] = newTit
                        self.PFresultsShown = true;
                        self.searching = false;
                    }
                    self.searchObj.pfcf = "";
                    self.searchObj.ndg = "";
                    self.disableButtonAddEstero = false;
                }

            })
            .catch(function (error) {
                console.log(error);
                self.PFresultsShown = true;
                self.searching = false;
                self.disableButtonAddEstero = false;
            })
    }

    self.getRelatedPersonByNsil = function (searchForNdg) {
        self.disableButtonAddEstero = true;
        self.tempPerson = [];
        self.searching = false;
        self.searchingForeign = true;
        self.addForeign = true;
        self.openSectionUpgradePf = false;
        self.PFresultsShown = true;
        var customer = FinancialCustomer.build({
            ndg: self.ndgCli,
        });

        customer.metadata = null;
        $financialApiService
            .getRelatedPersonByNsil(customer, true)
            .then(function (response) {
                if (response.success && response.listAppCustomer) {
                    var pfNotPresent = response.listAppCustomer.filter(a => !self.ndgIsPresentAndHidden(a.ndg) && !self.listPf.map(p => p.ndg).includes(a.ndg));
                    if (pfNotPresent.length > 0) {
                        pfNotPresent.forEach(appCustomerUser =>
                        $financialApiService
                            .getSearchRiUserG(appCustomerUser)
                            .then(function (appCustomer) {
                                if (appCustomer.success) {
                                    appCustomer.appCustomerUser.metadata.riUserG.sedeLegale.stato = appCustomer.appCustomerUser.metadata.riUserG.sedeLegale.statoEsteso
                                    if (appCustomer.appCustomerUser.metadata.riUserG.isEstero) {
                                        var codCityOfBirth = self.nazioni.find(function (element) {
                                            if (!appCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato) {
                                                if (!!appCustomer.appCustomerUser.metadata.riUserG.datiNascita.statoEsteso && !!appCustomer.appCustomerUser.metadata.riUserG.datiNascita.statoEsteso.name) {
                                                    appCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato = appCustomer.appCustomerUser.metadata.riUserG.datiNascita.statoEsteso
                                                } else if (!!appCustomer.appCustomerUser.metadata.riUserG.datiNascita.nazione) {
                                                    appCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato = {
                                                        name: appCustomer.appCustomerUser.metadata.riUserG.datiNascita.nazione
                                                    }
                                                }
                                            }
                                            return element.name.toUpperCase() == appCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato.name.toUpperCase()
                                        }).value
                                        if (!appCustomer.appCustomerUser.metadata.riUserG.sesso) {
                                            appCustomer.appCustomerUser.metadata.riUserG.sesso = "m"
                                        }
                                        appCustomer.appCustomerUser.metadata.riUserG.idEstero = validationService.createCf(appCustomer.appCustomerUser.metadata.riUserG.nome, appCustomer.appCustomerUser.metadata.riUserG.cognome, appCustomer.appCustomerUser.metadata.riUserG.datiNascita.data, appCustomer.appCustomerUser.metadata.riUserG.sesso, codCityOfBirth)
                                    }

                                    if (appCustomer.appCustomerUser.metadata.riUserG.domicilioDiverso && appCustomer.appCustomerUser.metadata.riUserG.domicilio) {
                                        appCustomer.appCustomerUser.metadata.riUserG.domicilio.stato = appCustomer.appCustomerUser.metadata.riUserG.domicilio.statoEsteso

                                    }

                                    var comuni = self.comuni.concat(self.comuniNsil);
                                    var newUser = Pf.build(appCustomer.appCustomerUser.metadata.riUserG);
                                    appCustomer.appCustomerUser.metadata.riUserG.datiNascita = newUser.datiNascita;
                                    appCustomer.appCustomerUser.metadata.riUserG.sesso = newUser.sesso;
                                    newUser = convertDateToTit(appCustomer.appCustomerUser.metadata.riUserG)
                                    var newTit = createNewTit(newUser);
                                    var titIndex = self.listPf.findIndex(pf => newTit.idEstero == pf.idEstero && newTit.ndg && !pf.ndg);
                                    if (titIndex > -1) {
                                        self.listPf.splice(titIndex, 1, newTit);
                                    } else {
                                        self.tempPerson.push(newTit);
                                    }
                                    self.searchingForeign = false;
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                                self.searchingForeign = false;
                                self.disableButtonAddEstero = false;
                            })
                        )
                    } else {
                        self.searchingForeign = false;
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                self.searchingForeign = false;
                self.disableButtonAddEstero = false;
            })
    }

    var convertDateToTit = function (user) {
        var temp = {
            nome: user.nome,
            cognome: user.cognome,
            cf: user.cf,
            datiNascita: user.datiNascita,
            sedeLegale: user.sedeLegale || user.residenza,
            ndg: user.ndg,
            domicilioDiverso: user.domicilioDiverso,
            domicilio: user.domicilio,
            isEstero: user.isEstero,
            documento: user.documento,
            sesso: user.sesso,
            cittadinanza: user.cittadinanza,
            deleted: user.deleted,
            idEstero: user.idEstero,
            residenza: user.residenza
        }

        return temp;

    }

    self.annulla = function (index) {
        self.listPf[index].annullatoFe = true;
        self.listPf[index].riattivatoFe = false;
        self.checkComponent();
    }

    self.riabilita = function (index) {
        self.listPf[index].riattivatoFe = true;
        self.listPf[index].annullatoFe = false;
        self.checkComponent();
    }

    self.userAlreadyAdded = function (searchFromNdg, id) {

        if (searchFromNdg) {
            return self.listPf.some(x => {
                return !!id ? x.ndg == id : !!self.searchObj.ndg && x.ndg == self.searchObj.ndg
            })

        } else {
            return self.listPf.some(x => {
                return !!id ? 
                    x.cf == id || x.idEstero == id : 
                    !!self.searchObj.pfcf && (x.cf == self.searchObj.pfcf || x.idEstero == self.searchObj.pfcf)
            })
        }
    }

    var createNewTit = function (dateOfRest) {
        var newTit = {
            area: self.domini.area,
            cf: dateOfRest && dateOfRest.cf || null,
            cognome: dateOfRest && dateOfRest.cognome || null,
            cittadinanza: dateOfRest && dateOfRest.cittadinanza,
            datiNascita: dateOfRest && dateOfRest.datiNascita,
            sesso: dateOfRest && dateOfRest.sesso,
            descrizione: self.domini.descrizione,
            documento: dateOfRest && Documento.build(dateOfRest.documento) || Documento.build(),
            domicilio: dateOfRest && (dateOfRest.domicilio || dateOfRest.residenza) || null,
            domicilioDiverso: dateOfRest && dateOfRest.domicilioDiverso || false,
            editable: true,
            id: "pef",
            ndg: dateOfRest && dateOfRest.ndg || null,
            nome: dateOfRest && dateOfRest.nome || null,
            originePatrimonio: self.domini.originePatrimonio,
            originePatrimonioMex: null,
            pep: {
                carica: self.domini.carica,
                description: "pep_base",
                editable: false,
                id: "pep_base",
                origineFondi: self.domini.origineFondi,
                origineFondiDescr: null,
                paeseOrigine: null,
                pep: null,
                pepFinanziamenti: false,
                relazione: self.domini.relazione,
                relazioneDescr: null,
                visible: false
            },
            professione: self.domini.professione,
            professionePrec: self.domini.professionePrec,
            ragioneSociale: null,
            relazioneTitCli: self.domini.relazioneTitCli,
            sedeLegale: Sede.build(dateOfRest && dateOfRest.sedeLegale),
            residenza: Sede.build(dateOfRest && dateOfRest.residenza),
            settore: self.domini.settore,
            isEstero: dateOfRest && dateOfRest.isEstero,
            isOk: dateOfRest && dateOfRest.isOk,
            deleted: dateOfRest && dateOfRest.deleted,
            idEstero: dateOfRest && dateOfRest.idEstero

        }
        self.supportModel = {
            ruolo: null,
            professione: null,
            professionePrec: null,
            relazionePep: null,
            originePatrimonio: null,
            settore: null,
            areaGeoSvolgimento: null,
            relazioneTitCliente: null,
            caricaIstituzionale: null,
            originePatrimonioPEP: null
        }

        return newTit;

    }

    self.addPfEstero = function () {
        self.tempPerson = [];
        self.tempPerson.push(createNewTit(
            { 
                sedeLegale: { 
                    provincia: 'EE' 
                },
                residenza: { 
                    provincia: 'EE' 
                },
                domicilio: { 
                    stato: {
                        value: null,
                        name: null,
                        description: null
                    },
                    statoEsteso: {
                        value: null,
                        name: null,
                        description: null
                    }
                }
            }
        ));
        self.openSectionUpgradePf = true;
    }

    self.closeSectionUpdatePf = function () {
        self.tempPerson = [];
        self.openSectionUpgradePf = false;
    }

    self.closeSectionAddPf = function () {
        self.addForeign = false;
        self.disableButtonAddEstero = false;
        self.PFresultsShown = false;
        self.closeSectionUpdatePf();
    }

    self.completaPfEstero = function () {
        var idEstero = validationService.createCf(self.tempPerson[0].nome, self.tempPerson[0].cognome, self.tempPerson[0].data, self.tempPerson[0].sesso, self.tempPerson[0].datiNascita.stato.value)
        if (self.userAlreadyAdded(false, idEstero)) {
        $rootScope.$broadcast("addAlert", {
            text: "ALREADY_ADDED"
        });
            return
        }
        self.tempPerson[0].idEstero = idEstero;
        self.tempPerson[0].datiNascita.comune = self.tempPerson[0].datiNascita.stato.name;
        self.tempPerson[0].datiNascita.provincia = "EE";
        var comuni = self.comuni.concat(self.comuniNsil);
        var temporanyUser = Pf.build(self.tempPerson[0]).setDefaultPfValues(self.nazioni, comuni);
        var newUser = convertDateToTit(temporanyUser)
        var newTit = createNewTit(newUser);
        if (!newTit.datiNascita.data) {
            newTit.datiNascita.data = self.tempPerson[0].data;
        }
        newTit.isEstero = true;
        self.listPf.push(newTit)
        self.openSectionUpgradePf = false;
        self.tempPerson = [];
        self.checkComponent();
    }

    self.addPfToList = function (tempPerson) {
        self.listPf.push(tempPerson)
        self.tempPerson.splice(self.tempPerson.findIndex(e => e.ndg === tempPerson.ndg || e.cf === tempPerson.cf), 1);
        if (self.tempPerson.length === 0 && !self.addForeign) {
            self.closeSectionAddPf();
        }
        self.checkComponent();
        checkTitDeleted();

    }

    self.editPf = function (pf) {
        self.userDaCensire = pf;
        self.enableModal = true;
        self.createListComuniNascita(self.userDaCensire.datiNascita.provincia);
        self.createListComuniRilascio(self.userDaCensire.documento.provincia);
        self.createListDocumenti(self.userDaCensire.documento.tipo);
        self.verifyDate();

        
        //RN:12378303
        //self.userDaCensire.firmatario.spid = false;  

        if (self.userDaCensire.firmatario){
            self.userDaCensire.firmatario.spid = 'N';  
        }
        
/*
        var tmp = {
            firmatario: {"spid": 'N'}
        }
        Object.assign(self.userDaCensire, tmp);
  */
        console.log("USER DA CENSIRE ", self.userDaCensire);


        setDefaultDate();
        $timeout(function () {
            $modalService.openModal('arricchimentoTit-modal');
            $("#footerInstant").css("z-index", "-1");
            $('.financial-leasing__footer').css("z-index", "-1");
        }, 300);

    }

    self.undoDocumentChanges = function () {
        $modalService.closeModal("arricchimentoTit-modal");
        self.enableModal = false;
        $("#footerInstant").css("z-index", "2");
        $('.financial-leasing__footer').css("z-index", "2");
        jQuery('.mCSB_scrollTools').css("z-index", "2");
        self.listaComuniNascita = [];
        self.listaNomeComuniRilascio = [];
    }

    self.createListComuniNascita = function (provincia) {
        var comuni = self.comuni.concat(self.comuniNsil);
        self.listaComuniNascita = comuni
            .filter(function (comune) {
                return comune.sigla == provincia;
            });
    }

    self.createListComuniRilascio = function (provincia, resetComune) {

        if (provincia != 'EE' && provincia != 'SE') {
            self.listaNomeComuniRilascio = self.comuni
                .filter(function (comune) {
                    return comune.sigla == provincia
                });
        }
        if (resetComune) {
            self.userDaCensire.documento.luogoEsteso = null;
            self.userDaCensire.documento.luogo = null;
            self.userDaCensire.documento.statoEsteso = {};

        }
    }

    self.createListDocumenti = function (tipo, changedDoc) {
        var documento = self.dropdown.tipiDocumento.find(x => {
            return x.value == tipo
        })
        self.showDownloadExample = documento && documento.additionalProperty == 1 ? true : false;
        generateLinkExampleDoc(tipo);
        self.listaNomeRilascio = Documento.getEntiRilascio(tipo)
        if (changedDoc) {
            self.documentUpload = [];
            self.userDaCensire.documento = Documento.build({ tipo: tipo })
        }
        self.refreshRegex = true;
        $timeout(function () {
            self.refreshRegex = false;
        }, 200)

        if (tipo == 'CAE' || tipo == 'UCO') {


            if (tipo == 'UCO') {
                self.disableEnteRilascioProvinciaUco = true;
                self.userDaCensire.documento.provincia = 'RM';
                self.createListComuniRilascio(self.userDaCensire.documento.provincia, true)
                var roma = self.comuni
                    .find(function (comune) {
                        return comune.nome.toLowerCase() == 'roma';
                    });
                self.userDaCensire.documento.luogoEsteso = roma;
                self.userDaCensire.documento.enteRilascio = self.listaNomeRilascio.find(x => {
                    return x.name.toUpperCase() == 'MINISTERO'
                })
            } else {
                self.disableEnteRilascioProvinciaCae = true;
                self.userDaCensire.documento.provincia = 'EE'
                self.createListComuniRilascio(self.userDaCensire.documento.provincia)
            }



        } else {
            self.disableEnteRilascioProvinciaCae = false;
            self.disableEnteRilascioProvinciaUco = false;
        }

        if (self.userDaCensire.documento && self.userDaCensire.documento.tipo) {


            if (tipo == 'UCO') {
                self.userDaCensire.documento.enteRilascio = self.listaNomeRilascio.find(x => {
                    return x.name.toUpperCase() == 'MINISTERO'
                })
            } else {
                self.userDaCensire.documento.enteRilascio = self.listaNomeRilascio[0];
            }
        } else {
            self.userDaCensire.documento.enteRilascio = null
        }

        if (self.userDaCensire.ndg && !self.isPagoDopo && changedDoc && $portalService.isAra()) {
            $financialApiService
                .getIdentityDocument(
                    self.userDaCensire.ndg,
                    self.userDaCensire.documento.tipo
                )
                .then(function (response) {
                    if (response.success) {
                        self.userDaCensire.documento.dataRilascio =
                            response.document.dataRilascio;
                        self.userDaCensire.documento.dataScadenza =
                            response.document.dataScadenza;
                        self.userDaCensire.documento.luogoEsteso = {
                            nome: response.document.luogo,
                        };
                        self.userDaCensire.documento.luogo = response.document.luogo
                        self.userDaCensire.documento.enteRilascio.name =
                            response.document.enteRilascio;
                        self.userDaCensire.documento.provincia =
                            response.document.provincia;
                        self.userDaCensire.documento.numero = response.document.numero;
                        self.userDaCensire.documento.id = response.document.id;

                        if ((response.document.provincia == "EE" || response.document.provincia == "SE") && response.document.luogo) {
                            self.userDaCensire.documento.statoEsteso = self.nationsList
                                .find(x => {
                                    return x.name.toUpperCase() == response.document.luogo.toUpperCase();
                                })
                        } else {
                            self.userDaCensire.documento.statoEsteso = {
                                name: 'ITALIA',
                                value: 'Z999',
                                description: '086'
                            }
                        }
                    }
                    $timeout(function () {

                    }, 1000)
                })
                .catch(function (error) {
                    console.log(error);
                });

        }
    }

    self.setStatoRilascio = function () {
        self.userDaCensire.documento.statoEsteso = self.nationsList
            .find(x => {
                return x.name.toUpperCase() == self.userDaCensire.documento.luogo.toUpperCase();
            })
    }

    self.verifyDate = function () {
        var sesso = "";
        if (!self.userDaCensire.cf) {
            sesso = self.userDaCensire.sesso
        } else {
            var giornoNascita = self.userDaCensire.cf && self.userDaCensire.cf.substring(9, 11);
            sesso = giornoNascita > 40 ? 'F' : 'M'
        }
        var codCat = "";
        if (self.userDaCensire.datiNascita.provincia != 'EE' && self.userDaCensire.datiNascita.provincia != 'SE') {
            var comuni = self.comuni.concat(self.comuniNsil);
            codCat = self.userDaCensire.datiNascita.comune &&
                comuni.find(function (element) {
                    return element.nome.toUpperCase() == self.userDaCensire.datiNascita.comune.toUpperCase()
                }).codiceCatastale;
            if (!codCat) {

                codCat = self.userDaCensire.datiNascita.luogoEsteso && self.userDaCensire.datiNascita.luogoEsteso.nome &&
                    comuni.find(function (element) {
                        return element.nome.toUpperCase() == self.userDaCensire.datiNascita.luogoEsteso.nome.toUpperCase()
                    }).codiceCatastale;

            }
        } else {
            codCat = self.nazioni.find(function (element) {
                return element.name.toUpperCase() == self.userDaCensire.datiNascita.stato.name.toUpperCase();
            }).value
        }
        self.testDati = validationService.checkCfWithFieds(
            self.userDaCensire.cf || self.userDaCensire.idEstero,
            self.userDaCensire.nome,
            self.userDaCensire.cognome,
            self.userDaCensire.datiNascita.data,
            sesso,
            codCat
        );

    };


    self.validateForm = function () {

        return $scope.forms.genericForm &&
            $scope.forms.genericForm.$valid &&
            (self.testDati && self.testDati.value) &&
            ((self.userDaCensire && self.userDaCensire.documento &&
                !!self.userDaCensire.documento.uploadedDoc && !!self.userDaCensire.documento.uploadedDoc.length) || self.startQuestionario.smallTicket)

    }

    var setDefaultDate = function () {

        if (self.userDaCensire.documento.idImgDocumentoFront) {
            var temp = {
                name: '',
                type: "imgDocument",
                selected: false,
                side: "front",
                typeDocument: self.userDaCensire.documento.tipo,
                downloadLink: "",
                cdDoc: self.userDaCensire.documento.tipo,
                id: null,
                downloadKey: self.userDaCensire.documento.idImgDocumentoFront
            };
            if (self.userDaCensire.documento && !!!self.userDaCensire.documento.uploadedDoc) {
                self.userDaCensire.documento.uploadedDoc = [];

            }
            self.userDaCensire.documento.uploadedDoc.push(temp);
            self.userDaCensire.documento.idImgDocumentoFront = null
        }
        // if (self.userDaCensire.documento.idImgDocumentoCfFront) {
        //     var temp = {
        //         name: '',
        //         type: 'CF',
        //         selected: false,
        //         side: "front",
        //         typeDocument: 'CF',
        //         downloadLink: "",
        //         cdDoc: 'CF',
        //         id: self.userDaCensire.documento.idImgDocumentoCfFront,
        //         downloadKey: self.userDaCensire.documento.idImgDocumentoCfFront
        //     };
        //     self.documentUpload.push(temp);

        // }

        if ((self.userDaCensire.documento.provincia == "EE" || self.userDaCensire.documento.provincia == "SE") && self.userDaCensire.documento.luogo) {
            self.userDaCensire.documento.statoEsteso = self.nationsList
                .find(x => {
                    return x.name.toUpperCase() == self.userDaCensire.documento.luogo.toUpperCase()
                })
        } else {
            self.userDaCensire.documento.statoEsteso = {
                name: 'ITALIA',
                value: 'Z999',
                description: '086'
            }
        }

        self.supportModel = {
            ruolo: null,
            professione: null,
            professionePrec: null,
            relazionePep: null,
            originePatrimonio: null,
            settore: null,
            areaGeoSvolgimento: null,
            relazioneTitCliente: null,
            caricaIstituzionale: null,
            originePatrimonioPEP: null
        }
        // inserire qui le funzioni per il popolamento dei dati già valorizzati
        popolateDefaultValue();
    }

    var popolateDefaultValue = function () {
        self.supportModel.relazioneTitCliente = self.userDaCensire.relazioneTitCli && self.userDaCensire.relazioneTitCli.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.professione = self.userDaCensire.professione && self.userDaCensire.professione.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.professionePrec = self.userDaCensire.professionePrec && self.userDaCensire.professionePrec.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.settore = self.userDaCensire.settore && self.userDaCensire.settore.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.areaGeoSvolgimento = self.userDaCensire.area && self.userDaCensire.area.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.originePatrimonio = self.userDaCensire.originePatrimonio && self.userDaCensire.originePatrimonio.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.caricaIstituzionale = self.userDaCensire.pep && self.userDaCensire.pep.carica && self.userDaCensire.pep.carica.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.relazionePep = self.userDaCensire.pep && self.userDaCensire.pep.relazione && self.userDaCensire.pep.relazione.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.originePatrimonioPEP = self.userDaCensire.pep && self.userDaCensire.pep.origineFondi && self.userDaCensire.pep.origineFondi.find(function (sel) {
            return sel.selected == true;
        })
    }

    self.handleChange = function (tipo, subType, valueSelected) {
        if (subType) {
            self.userDaCensire[tipo][subType].forEach(function (element) {
                if (element.value == valueSelected.value) {
                    element.selected = true;
                } else {
                    element.selected = false;
                }
            })

        } else {
            self.userDaCensire[tipo].forEach(function (element) {
                if (element.value == valueSelected.value) {
                    element.selected = true;
                } else {
                    element.selected = false;
                }
            })
        }

        if (tipo === 'professione') {
            if (valueSelected.name === "Casalinga" || valueSelected.name === "Pensionato" || valueSelected.name === "Non occupato") {
                self.enablePreviusJob = true;
            } else {
                self.enablePreviusJob = false;
            }
        }

        console.log('userDaCensire--->', self.userDaCensire)
    }

    self.savePfData = function (pf) {
        $rootScope.$broadcast('titolareChanged', pf);
        $rootScope.$broadcast("pageLoader", {
            action: "OPEN"
        });
        //Solo ai fini della stampa del documento metto in Uppercase nome e cognome e numero documento
        pf.nome = pf.nome && pf.nome.toUpperCase();
        pf.cognome = pf.cognome && pf.cognome.toUpperCase();
        pf.documento.numero = pf.documento.numero && pf.documento.numero.toUpperCase();
        var index = self.listPf.findIndex(x => {
            return x.cf ? x.cf === pf.cf : x.idEstero === pf.idEstero
        })
        if (self.externalLink) {
            $rootScope.$broadcast("pageLoader", {
                action: "CLOSE"
            });
            pf.isOk = true;
            self.listPf[index] = pf;
            $modalService.closeModal("arricchimentoTit-modal");
            self.enableModal = false;
            $("#footerInstant").css("z-index", "2");
            $('.financial-leasing__footer').css("z-index", "2");

        } else {

            pf.residenza = pf.sedeLegale;
            pf.residenza.statoEsteso = pf.residenza.stato;
            $financialApiService.updatePersonalActivityDigital(null, Pf.build(pf), false)
                .then(function (response) {
                    self.enableLoader = false;
                    $rootScope.$broadcast("pageLoader", {
                        action: "CLOSE"
                    });
                    if (!response.success) {
                        console.log(response)
                        self.listPf[index].isOk = false;
                    } else {
                        pf.isOk = true;
                        self.listPf[index] = pf;
                        $modalService.closeModal("arricchimentoTit-modal");
                        self.enableModal = false;
                        $("#footerInstant").css("z-index", "2");
                        $('.financial-leasing__footer').css("z-index", "2");
                    }
                    self.checkComponent();
                })
                .catch(function (error) {
                    self.checkComponent();
                    console.log(error);
                    self.listPf[index].isOk = false;
                    $rootScope.$broadcast("pageLoader", {
                        action: "CLOSE"
                    });

                })

        }
        self.checkComponent();

    }

    self.removePf = function (pf, indice) {
        self.loaderRemove[indice] = true;
        $uniService.
            deleteDocsPfAdv(self.startQuestionario.id, pf.cf, pf.idEstero)
            .then(response => {
                if (response.success) {
                    self.listPf.splice(indice, 1);
                    self.checkComponent();
                    checkTitDeleted();

                }
                self.loaderRemove[indice] = false;
            })
            .catch(error => {
                self.loaderRemove[indice] = false;
                console.log(error);
            })

    }

    // sezione upload
    self.uploader = new FileUploader({
        url: "",
        headers: {
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
            "App-Name": $rootScope.portalName,
        },
    });

    self.uploadDataFunc = function (item, index, privacy, type, side) {
        var document =
            arguments.length > 3 && arguments[3] !== undefined ?
                arguments[3] :
                false;
        if (item) {
            self.uploadData = item;
        }
        self.typeTempDocument = type;
        self.isPrivacyUpload = privacy;
        self.uploadDocumenti = document;
        self.currentCodeTypeNameIndex = index;
        self.sideUploaded = side;
    };
    self.finalUpload = function (item) {
        console.log("calling finalUpload");
        var url =
            $configService.getAppConfig().url +
            "/uni/upload/service-infos///FINANCIAL_PD";

        for (var int = 0; int < self.uploader.queue.length; int++) {
            self.uploader.queue[int].url = url;
        }
        if (self.typeTempDocument == 'CF') {
            var fileFront = document.querySelector(
                "#uploadInputCF_front").files[0];
            var fileBack = document.querySelector(
                "#uploadInputCF_back").files[0];

        } else {
            var fileFront = document.querySelector(
                "#uploadInput_front").files[0];
            var fileBack = document.querySelector(
                "#uploadInput_back").files[0];

        }

        var file;
        if (fileFront) {
            file = fileFront;
        } else {
            file = fileBack;
        }
        var tipo = self.typeTempDocument;
        var reader = new FileReader();
        var fronte = self.sideUploaded == "front" ? true : false;
        reader.onload = function (event) {
            var formData = new FormData();
            jQuery("#uploadInput_front").val("");
            jQuery("#uploadInput_back").val("");
            appendToForm(formData, "file", file);
            appendToForm(formData, "type", "GENERAL_PERSONAL_DOCUMENTS");
            appendToForm(formData, "cdDoc", tipo);
            appendToForm(formData, "filename", file.name);
            appendToForm(formData, "idPratica", self.startQuestionario.id);
            appendToForm(formData, "personal", true);
            appendToForm(formData, "fronte", fronte);
            appendToForm(formData, "cfSoggetto", self.userDaCensire.cf);
            appendToForm(formData, "ndgSoggetto", self.userDaCensire.ndg);
            appendToForm(formData, "idEstero", self.userDaCensire.idEstero);

            $uniService
                .uploadDocOnAdv(formData)
                .then(function (response) {
                    if (!response.success) {
                        if (self.typeTempDocument == 'CF') {
                            self.visualProgBarCF = false;
                        } else {
                            self.visualProgBarDoc = false;
                        }
                        self.disabledForUploadingInProgress = false;
                        if (self.sideUploaded == "front") {
                            self.disabeldUploadFront = false;
                        } else {
                            self.disabeldUploadBack = false;
                        }
                        $rootScope.$broadcast("addAlert", {
                            text: "ERROR_UPLOAD"
                        });

                        return;
                    }

                    $timeout(function () {
                        var temp = {};
                        temp = {
                            name: file.name,
                            type: "imgDocument",
                            selected: false,
                            side: self.sideUploaded,
                            typeDocument: self.typeTempDocument,
                            downloadLink: "",
                            cdDoc: self.typeTempDocument,
                            id: response.id,
                            imgDocumentoFront: response.downloadKey,
                            downloadKey: response.downloadKey
                        };


                        if (self.sideUploaded == "front") {
                            self.disabeldUploadFront = true;
                        } else {
                            self.disabeldUploadBack = true;
                        }
                        if (self.userDaCensire.documento && !!!self.userDaCensire.documento.uploadedDoc) {
                            self.userDaCensire.documento.uploadedDoc = [];
                        }

                        self.userDaCensire.documento.uploadedDoc.push(temp);

                        self.disableInput = false;

                        if (self.typeTempDocument == 'CF') {
                            self.visualProgBarCF = false;
                        } else {
                            self.visualProgBarDoc = false;
                        }
                        // if (self.typeTempDocument == "CF") {
                        //     self.userDaCensire.documento.idImgDocumentoCfFront = response.downloadKey;
                        // } else {
                        //     self.userDaCensire.documento.idImgDocumentoFront = response.downloadKey;

                        // }

                        $timeout(function () {
                            self.disabledForUploadingInProgress = false;
                        }, 1000);
                    }, 40);
                })
                .catch(function (error) {
                    if (self.typeTempDocument == 'CF') {
                        self.visualProgBarCF = false;
                    } else {
                        self.visualProgBarDoc = false;
                    }
                    self.disabledForUploadingInProgress = false;
                    if (self.sideUploaded == "front") {
                        self.disabeldUploadFront = false;
                    } else {
                        self.disabeldUploadBack = false;
                    }
                });

        };
        if (file) {
            reader.readAsArrayBuffer(file);
        }
    };
    self.uploader.onAfterAddingFile = function (fileItem) {
        self.disabledForUploadingInProgress = true;
        console.log("fileItem", fileItem);
        self.progresso = 0;
        if (fileItem.file.size > 26214400) {
            $rootScope.$broadcast("addAlert", {
                text: "MAXIMUM_FILE_SIZE_EXCEEDED",
            });
            fileItem.remove();
            jQuery("#uploadInput_back").val("");
            jQuery("#uploadInput_front").val("");
        }
        var fileName = fileItem.file.name;
        if (
            fileName.toLowerCase().indexOf(".png") > -1 ||
            fileName.toLowerCase().indexOf(".jpg") > -1 ||
            fileName.toLowerCase().indexOf(".jpeg") > -1 ||
            fileName.toLowerCase().indexOf(".tiff") > -1 ||
            fileName.toLowerCase().indexOf(".pdf") > -1 ||
            fileName.toLowerCase().indexOf(".zip") > -1
        ) {
            self.uploader.queue[0].progress = 100;

            if (self.typeTempDocument == 'CF') {
                self.visualProgBarCF = true;
            } else {
                self.visualProgBarDoc = true;
            }

            $timeout(function () {
                self.progresso = 100;
            }, 500);
        } else {
            fileItem.remove();
            jQuery("#uploadInput_back").val("");
            jQuery("#uploadInput_front").val("");
            $rootScope.$broadcast("addAlert", {
                text: "FORMAT_NOT_SUPPORTED",
            });
            self.disabledForUploadingInProgress = false;
        }
    };

    self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
    };

    self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
        self.disableInput = true;
    };

    self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
    };

    self.uploader.onProgressAll = function (progress) { };

    self.uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
    ) { };

    self.uploader.onErrorItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        console.info("onErrorItem", fileItem, response, status, headers);
        jQuery("#uploadInput_back").val("");
        jQuery("#uploadInput_front").val("");
        $rootScope.$broadcast("addAlert", {
            text: "ERROR_UPLOADING_FILE",
        });

        self.disableInput = false;
        $timeout(function () {
            if (self.typeTempDocument == 'CF') {
                self.visualProgBarCF = false;
            } else {
                self.visualProgBarDoc = false;
            }
        }, 4000);

        fileItem.remove();
        jQuery("#uploadInput_back").val("");
        jQuery("#uploadInput_front").val("");
    };

    self.uploader.onCancelItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        console.log(status);
    };

    self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (
            response &&
            response.uploadFileServicePojo &&
            response.uploadFileServicePojo.success
        ) {

        }
        self.uploader.queue = [];

        self.disableInput = false;
        $timeout(function () {
            if (self.typeTempDocument == 'CF') {
                self.visualProgBarCF = false;
            } else {
                self.visualProgBarDoc = false;
            }

            self.disabledForUploadingInProgress = false;
        }, 4000);
        jQuery("#uploadInput_back").val("");
        jQuery("#uploadInput_front").val("");
    };

    self.uploader.onCompleteAll = function () {
        console.info("onCompleteAll");
        self.uploadCompleted = true;
    };

    self.uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        self.uploading = false;
    };

    self.check = function (el) {
        el.selected = !el.selected;
    };

    self.trashCanEnabledDoc = function () {
        return !!self.userDaCensire &&
            !!self.userDaCensire.documento &&
            !!self.userDaCensire.documento.uploadedDoc &&
            self.userDaCensire.documento.uploadedDoc.some(function (element) {
                return element.selected == true;
            })
    }

    self.deletePrivacyDocument = function (type) {
        self.progresso = 100;

        if (type == 'CF') {
            self.visualProgBarCF = true;
        } else {
            self.visualProgBarDoc = true;
        }
        var temp = self.userDaCensire.documento.uploadedDoc.filter(x => {
            return x.selected == true;
        });
        temp.forEach(function (element) {
            $simulationService
                .deleteChecklistFileAdv(element.id)
                .then(function (response) {
                    console.log(response);
                    self.progresso = 0;
                    if (response.success) {

                        // self.documentUpload = self.documentUpload.filter(x => {
                        //     return x.type != type
                        // })
                        self.userDaCensire.documento.uploadedDoc = self.userDaCensire.documento.uploadedDoc.filter(x => {
                            return x.selected == false;
                        });

                        // if (type == 'CF') {
                        //     self.userDaCensire.documento.idImgDocumentoCfFront = ""

                        // } else {
                        //     self.userDaCensire.documento.idImgDocumentoFront = ""
                        // }

                        self.uploadOk = false;
                    }
                    if (type == 'CF') {
                        self.visualProgBarCF = false;
                    } else {
                        self.visualProgBarDoc = false;
                    }
                })
                .catch(function (error) {
                    $rootScope.$broadcast("addAlert", {
                        text: "ERROR_TEC",
                    });
                });

        });
    }

    self.downloadFiles = function (file) {
        var url = "/uni/downloadDocAdv/service-infos/";
        var input = {
            downloadKey: file.downloadKey
        }

        $download.getGenericDownload(url, input)
            .then(function (response) {
                console.log(response)
            })
    }

    // fine sezione upload
    self.setDate = function (dataNascita, newData, tempPerson) {

        self.tempPerson[0][dataNascita] = newData;

    }

    self.setDocData = function (tipoData, newData) {
        self.userDaCensire.documento[tipoData] = newData;
    }

    self.ndgIsPresentAndHidden = function (ndg) {
        var test = false;
        self.listPf.forEach(x => {
            if (x.ndg == ndg && x.hide) {
                x.hide = false;
                test = true;
            }
        })
        return test;
    }

    self.userIsPresentAndHidden = function (searchFromNdg) {
        var test = false;
        if (searchFromNdg) {
            test = self.ndgIsPresentAndHidden(self.searchObj.ndg)
        } else {
            self.listPf.forEach(x => {
                if (x.cf && x.cf.toUpperCase() == self.searchObj.pfcf.toUpperCase() && x.hide) {
                    x.hide = false;
                    test = true;
                }
            })
        }
        return test;
    }

    var checkTitDeleted = () => {

        self.listOfDisabledUser = self.listPf && self.listPf.filter(x => {
            return x.deleted == true;
        })

        self.enableMexUsersDisabled = !!self.listOfDisabledUser &&
            !!self.listOfDisabledUser.length
    }

    self.updateInfoStatoDocumento = function (value) {

        self.userDaCensire.documento.luogo = value.name;
        self.userDaCensire.documento.stato = value.name;

    }

    var checkTitolareFirmatario = function () {
        if (!self.isPostVendita) {
            return;
        }
        if (self.isFirmatari || self.isTitolari) {
            var user;
            var list = self.isFirmatari ? "titolari" : "firmatari";
            self.startQuestionario.metadataAdv[list][list].some(function (x) {
                if (x.cf == self.searchObj.pfcf) {
                    user = x;
                }
            });
        }
        return user;
    };

    var createIdEsteriFromTitEsteri = () => {
        self.listPf.forEach(tempPerson => {
            if (!!tempPerson.datiNascita.stato && !!!tempPerson.datiNascita.stato.value && !!tempPerson.datiNascita.stato.name) {
                var tempSato = self.nationsList.find(stato => {
                    return stato.name.toUpperCase() === tempPerson.datiNascita.stato.name.toUpperCase();
                })
                tempPerson.datiNascita.stato = tempSato
            }
            if (!!!tempPerson.idEstero && tempPerson.isEstero) {

                if (!!!tempPerson.sesso) {
                    tempPerson.sesso = 'M'
                }

                tempPerson.idEstero = validationService.createCf(tempPerson.nome, tempPerson.cognome, tempPerson.data, tempPerson.sesso, tempPerson.datiNascita.stato.value)
            }
        })
    }

    var getRoles = function () {
        $typeDomainService
            .getDomainSet("RI_DROPDOWN_DOMAINS", "ROLE")
            .then(function (response) {
                self.dropdown.ruolo = response.domainList;
            });
    };

    var generateLinkExampleDoc = function (tipoDocumento) {
        self.linkDownloadExampleDoc = $configService.getAppConfig().url +
            '/uni/download/service-infos/' +
            encodeURIComponent(tipoDocumento) +
            '/?token=' +
            $configService.getAppConfig().token;
    }

    self.setLuogo = () => {
        self.userDaCensire.documento.luogo = self.userDaCensire.documento.luogoEsteso && self.userDaCensire.documento.luogoEsteso.nome
    }

    self.showPfList = () => self.listPf.map(pf => !pf.hide).reduce((accumulator, currentValue) =>  accumulator || currentValue, false);
}